<template>
  <div class="page-content">
    <el-row class="operation">
      <el-button @click="toAddPage" type="primary">新增品类</el-button>
    </el-row>
    <!-- 数据展示区域 -->
    <el-row class="dataList">
      <el-table ref="multipleTable" border :data="tableData" tooltip-effect="dark" :cell-style="acellStyle"
        @cell-click="handleCellClick" :height="tableHeight" :header-cell-style="headCellStyle" style="width: 100%">
        <el-table-column prop="columnName" label="栏目名称">
        </el-table-column>
        <el-table-column prop="language" label="语言">
          <template slot-scope="scope">{{ scope.row.language === 0 ? '中文' : '英文' }}</template>
        </el-table-column>

        <el-table-column prop="atNumber" label="APP品类排序">
          <template slot-scope="scope">
            <el-input v-if="scope.row.atId === rowEditId" ref="input" clearable v-model="scope.row.atNumber"
              maxlength="3" @keyup.enter.native.lazy="$event.target.blur()" @input="inputChange(scope.row)"
              :autofocus="true" @blur="onBlur(scope.row)"></el-input>
            <span v-else>{{ scope.row.atNumber }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="createBy" label="创建者"></el-table-column>

        <el-table-column prop="createTime" label="创建时间">
        </el-table-column>

        <el-table-column prop="updateTime" label="修改时间">
          <template slot-scope="scope">{{ scope.row.updateTime || '---' }}</template>
        </el-table-column>

        <el-table-column label="操作" width="350">
          <template slot-scope="scope">
            <div>
              <!-- 1发布，0保存或下架 -->
              <el-button type="primary" size="mini" @click="detailHandle(scope.row)">编辑</el-button>
              <el-button type="primary" size="mini" @click="publishOrQuashHandle(scope.row)" v-if="scope.row.state === 0">发布</el-button>
              <el-button type="danger" size="mini" @click="publishOrQuashHandle(scope.row)" v-if="scope.row.state === 1">下架</el-button>
              <el-button type="danger" size="mini" @click="deleteHandle(scope.row)" v-if="scope.row.state === 0">删除</el-button>
            </div>
          </template>
        </el-table-column>

      </el-table>
    </el-row>
    <Paging :total="total" @changePage="changePage" />
  </div>
</template>
<script>
import { mixin } from '@/mixins/mixin.js'
import Paging from '@/components/paging'
import { debounce } from '@/utils/index'
import moment from 'moment'
import { guideList, isUse, isDel } from '@/api/appGuide'
import { listAppColumn, modifyAppColumnNumber, delAppColumn, publishOrQuashAppColumn } from '@/api/appCategory'
export default {
  mixins: [mixin],
  components: {
    Paging
  },
  data() {
    return {
      // 分页功能
      total: 0, // 到时候从后台获取
      searchParams: {
        pageNumber: 1,
        pageSize: 10
      },
      tableData: [],
      tableHeight: 600,
      // 点击编辑
      rowEditId: '',
      rowCategoryNumber: '',
      // 设置表格的样式
      acellStyle: { 'text-align': 'center' },
      headCellStyle: { 'text-align': 'center', 'font-weight': 'bold', 'font-size': '17px', color: 'black', 'background-color': '#f4f5f7' }
    }
  },
  created() {
    this.categoryAppListHandle();
    // 适配table高度
    this.getAutoHeight();
    let that = this;
    window.onresize = function () {
      that.getAutoHeight();
    };
  },
  methods: {
    publishOrQuashHandle(row) {
      let {atId, state} = row;
      state = state === 0 ? 1 : 0
      let params = {
        atId, 
        state
      }
      publishOrQuashAppColumn({
        params
      }).then(res => {
        this.categoryAppListHandle();
      })
    },
    deleteHandle({atId}) {      
      this.$confirm('是否确定删除该品类?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          atId
        }
        delAppColumn({
          params
        }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.categoryAppListHandle();
        })
      }).catch(() => {

      });
    },
    handleCellClick(row, column, cell, event) {
      // 检查点击的是哪一列
      if (column.property === 'atNumber') {
        this.rowEditId = row.atId;
        this.rowCategoryNumber = row.atNumber;
        this.$nextTick(() => {
          this.$refs.input.focus()
        })
      }
    },
    //输入框失焦事件
    onBlur(row) {
      let { atNumber, atId } = row;
      this.rowEditId = '';
      modifyAppColumnNumber({
        params: {
          atNumber, atId
        }
      }).then(res => {
        this.$message({
          type: 'success',
          message: '操作成功'
        })
        this.categoryAppListHandle();
      })
    },
    inputChange(row) {
      let { categoryNumber } = row;
      row.categoryNumber = Number(categoryNumber.replace(/\D/g, ""));
    },
    categoryAppListHandle() {
      listAppColumn({
        params: {}
      }).then((res) => {
        this.tableData = res.data.data
      })
    },
    getAutoHeight(gapDis = 280) {
      this.tableHeight = document.documentElement.clientHeight - gapDis;
    },
    detailHandle({ atId }) {
      this.$router.push({
        path: '/categoryManager/appCategory/edit',
        query: {
          atId
        }
      })

      // getAppColumnDetail({
      //   params: {
      //     categoryId
      //   }
      // }).then((res) => {

      //   this.$router.push({
      //     path: '/categoryManager/appCategory/edit',
      //     query: {
      //       obj: JSON.stringify(res.data.data)
      //     }
      //   })
      // })
    },
    handleChange(row) {
      const params = {
        id: row.guideId,
        isDelete: row.isUsed
      }
      isUse({ params }).then((res) => {
        this.getGuideList()
        if (res.data.code === 200) {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
        }
      }).catch(() => {
        // row.isUsed = !row.isUsed
        row.isUsed = ~row.isUsed + 2
      })
    },
    handlerViewClick(row, val) {
      const obj = {
        guideId: row.guideId,
        desc: 'view'
      }
      const params = {
        id: row.guideId,
        isDelete: 1
      }
      switch (val) {
        case 'view':
          this.$router.push({
            path: '/categoryManager/addAppGuide',
            query: {
              obj: JSON.stringify(obj)
            }
          })
          break
        case 'del':
          params.isDelete = 1
          this.$confirm('是否删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'error'
          }).then(() => {
            isDel({ params }).then((res) => {
              if (res.data.code === 200) {
                this.$message({
                  type: 'success',
                  message: '删除成功'
                })
                this.cutPage()
                this.getGuideList()
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
          break
        case 'use':
          params.isDelete = 0
          isUse({ params }).then((res) => {
            if (res.data.code === 200) {
              this.$message({
                type: 'success',
                message: '启用成功'
              })
              this.getGuideList()
            }
          })
          break
        case 'stop':
          params.isDelete = 1
          isUse({ params }).then((res) => {
            if (res.data.code === 200) {
              this.$message({
                type: 'success',
                message: '禁用成功'
              })
              this.getGuideList()
            }
          })
          break
      }
    },
    toAddPage() {
      this.$router.push({
        path: '/categoryManager/appCategory/edit'
      })
    },
    // 分页管理
    changePage(val) {
      this.searchParams = val
      this.getGuideList()
    }
  }
}
</script>

<style lang='less' scoped>
.operation {
  margin-bottom: 10px;
}
</style>
